<template>
  <div class="min-h-screen flex flex-col" @click="handleGlobalClick">
    <!-- 页眉 -->
    <Header @toggle-sidebar="toggleSidebar" data-no-intercept />
    
    <!-- 主体内容 -->
    <div class="flex flex-1">
      <!-- 侧边栏 - 桌面端显示 -->
      <Sidebar v-if="!isMobile" class="w-64 flex-shrink-0 sidebar" data-no-intercept />
      
      <!-- 移动端侧边栏遮罩 -->
      <Transition name="sidebar-overlay">
        <div 
          v-if="isMobile && sidebarVisible" 
          class="fixed inset-0 bg-black bg-opacity-50 z-40"
          @click="closeSidebar"
          data-no-intercept
        />
      </Transition>
      
      <!-- 移动端侧边栏 -->
      <Transition name="sidebar">
        <Sidebar 
          v-if="isMobile && sidebarVisible" 
          class="fixed left-0 top-0 h-full w-64 z-50 sidebar"
          @close="closeSidebar"
          data-no-intercept
        />
      </Transition>
      
      <!-- 主内容区 -->
      <main class="flex-1 overflow-auto h-[100vh] scrollbar-hide">
        <slot />
      </main>
    </div>
    
    <!-- 页脚 -->
    <Footer data-no-intercept />
    
    <!-- AI聊天助手 -->
    <ChatAssistant data-no-intercept />

    <!-- 全局APP下载弹窗 -->
    <QRCodeModal
      :is-visible="showAppDownloadModal"
      :title="modalTitle"
      :description="modalDescription"
      @close="closeQRModal"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useWindowSize } from '@vueuse/core'
import Header from './Header.vue'
import Sidebar from './Sidebar.vue'
import Footer from './Footer.vue'
import ChatAssistant from './ChatAssistant.vue'
import QRCodeModal from '@/components/common/QRCodeModal.vue'
import { useAppDownload } from '@/composables/useAppDownload'
import { useSEO } from '@/composables/useSEO'

// 响应式窗口尺寸
const { width } = useWindowSize()

// 移动端判断
const isMobile = computed(() => width.value < 768)

// 侧边栏显示状态
const sidebarVisible = ref(false)

// APP下载弹窗
const { 
  showAppDownloadModal, 
  modalTitle, 
  modalDescription, 
  closeQRModal, 
  handleGlobalClick 
} = useAppDownload()

// SEO优化
useSEO()

// 切换侧边栏
const toggleSidebar = () => {
  sidebarVisible.value = !sidebarVisible.value
}

// 关闭侧边栏
const closeSidebar = () => {
  sidebarVisible.value = false
}
</script>

<style scoped>
/* 侧边栏动画 */
.sidebar-enter-active,
.sidebar-leave-active {
  transition: transform 0.3s ease;
}

.sidebar-enter-from {
  transform: translateX(-100%);
}

.sidebar-leave-to {
  transform: translateX(-100%);
}

/* 遮罩动画 */
.sidebar-overlay-enter-active,
.sidebar-overlay-leave-active {
  transition: opacity 0.3s ease;
}

.sidebar-overlay-enter-from,
.sidebar-overlay-leave-to {
  opacity: 0;
}
</style>
    